import React from 'react';


import ConfigurationService from '../../services/configuration-service';
import StringProcessingService from '../../services/string-processing-service';

import './language-switch-style.css';

const listOfLanguages = require('../../configuration/languages/list.json');

class LanguageSwitch extends React.Component {
    configurationService = new ConfigurationService();
    stringProcessingService = new StringProcessingService();
    render() {

        let language = this.configurationService.getCurrentLanguagePrefix()
     
        let { allowedLanguages, articlesTranslations } = this.props;
        let renderLanguageList = []

        let pathname = document.location.pathname; 
        let search = document.location.search; 

        const currentPathParts = pathname.split('/').filter(Boolean);
        const isCurrentPathWithLang = listOfLanguages.some((item) => item.name === currentPathParts[0]);
        const pathWithoutLang = isCurrentPathWithLang
            ? `/${currentPathParts.slice(1).join('/')}`
            : pathname;
        const normalizedPathWithoutLang = pathWithoutLang === '' ? '/' : pathWithoutLang;

        const createLocalizedPath = (langName, targetPath, query = '') => {
            const cleanedTargetPath = targetPath.startsWith('/') ? targetPath : `/${targetPath}`;
            const pathWithLang = cleanedTargetPath === '/'
                ? `/${langName}`
                : `/${langName}${cleanedTargetPath}`;
            return `${pathWithLang}${query}`;
        };

        if (allowedLanguages != null) {
            for (let i = 0; i < listOfLanguages.length; i++) {
                if (allowedLanguages.includes(listOfLanguages[i].name)) renderLanguageList.push(listOfLanguages[i])
            }
        } else {
            for (let i = 0; i < listOfLanguages.length; i++) {
                if ((listOfLanguages[i].global)) renderLanguageList.push(listOfLanguages[i])
            }
        };
        return (
            <div className="LanguageSwitch">
                {
                    renderLanguageList.map((lang, index) => {
                        let hrefUrl = '';

                        if (articlesTranslations != null && articlesTranslations[lang.name] != null) {
                            const translatedArticle = articlesTranslations[lang.name];
                            hrefUrl = createLocalizedPath(
                                lang.name,
                                `/articles/${translatedArticle.id}/${this.stringProcessingService.StringFormatUrl(translatedArticle.title)}`
                            );
                        } else {
                            hrefUrl = createLocalizedPath(lang.name, normalizedPathWithoutLang, search);
                        }

                        if (allowedLanguages !== null && allowedLanguages !== undefined) {
                            if (allowedLanguages.length > 1) {
                                if (allowedLanguages.includes(lang.name)) {
                                    return (
                                        <React.Fragment key={lang.name}>
                                            <a href={hrefUrl} className={language === lang.name ? ('Current') : (null)}>{lang.name.toUpperCase()}</a>
                                            {index < renderLanguageList.length - 1 ? (<div>|</div>) : (null)}
                                        </React.Fragment>
                                    )
                                } else return null;
                            } else return null;


                        } else {
                            return (
                                <React.Fragment key={lang.name}>
                                    <a href={hrefUrl} className={language === lang.name ? ('Current') : (null)}>{lang.name.toUpperCase()}</a>
                                    {index < renderLanguageList.length - 1 ? (<div>|</div>) : (null)}
                                </React.Fragment>
                            )
                        }

                    })
                }
            </div>
        )
    }
}
export default LanguageSwitch;